import { useSEO } from "@/hooks/useSEO";

interface SEOProps {
  title: string;
  description: string;
  keywords: string;
  canonical?: string;
  ogImage?: string;
  ogType?: string;
  structuredData?: Record<string, any>;
  noIndex?: boolean;
}

export const SEO = ({ 
  title, 
  description, 
  keywords, 
  canonical, 
  ogImage, 
  ogType = "website", 
  structuredData, 
  noIndex = false 
}: SEOProps) => {
  useSEO({
    title,
    description,
    keywords,
    canonical,
    ogImage,
    ogType,
    structuredData,
    noIndex
  });

  return null;
};